import type { Valuation } from '../../hooks/valuationFragment';

export const hasOnlyFairValue = (valuation: Valuation) => {
  return (
    !valuation.futurePePercentageChange &&
    !valuation.revenuePercentageChange &&
    !valuation.profitMarginPercentageChange &&
    !!valuation.fairValue
  );
};
